import { take } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import useGroups from '@/hooks/contacts/use-groups';
import ROUTES from '@/routes';
import { ContactListItem } from './contact-list-item';

interface Props {
  count?: number;
}

export default function ContactGroupList({ count = 3 }: Props) {
  const { t } = useTranslation();
  const { data: groups } = useGroups();

  return (
    <div className='bg-base-100 px-5 py-2 mb-2'>
      <div className='bg-neutral-0 rounded px-5'>
        {take(groups, count).map((group) => (
          <Link
            key={group.ID}
            className='group'
            to={ROUTES.MESSAGES.GROUPS.$buildPath({ params: { id: group.ID } })}>
            <ContactListItem
              className='border-b px-0 border-base-100 group-last:border-none'
              item={group}
            />
          </Link>
        ))}
      </div>

      {groups.length > 3 && (
        <Link to={ROUTES.CONTACT.GROUPS.$path()}>
          <div className='text-blue-500 mt-2 text-sm inline-block'>
            {t('conversation.group.expand-all', { count: groups.length })}
          </div>
        </Link>
      )}
    </div>
  );
}
